// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles_hero__ffjnJ","bg_image":"styles_bg_image__uT8W_","bg_video":"styles_bg_video__DQj9F","content":"styles_content__YpjI0","description":"styles_description__XEAT2"};